import * as types from 'store/types';
import { update } from 'variables/utilities';

const initial = {
	error: null, request: null,
	loading: false
};

const started = (state, action) => {
	return update( state, {
		request: action.request,
		error: null, loading: true
	});
};

const succeeded = (state, action) => {
	const templates = (state.request === 'retrieve' && action.templates !== null) 
												? action.templates : state.templates;
	return update( state, {
		templates: templates,
		template: action.template,
		templateType: action.templateType,
		modifiedDate: new Date(),
		loading: false
	});
};

const failed = (state, action) => {
	return update( state, {
			error: action.error, loading: false
	});
}

const removed = (state, action) => {
	return update( state, {
		template: null, loading: false
	});
}

const templates = (state = initial, action) => {
	switch ( action.type ) {
		case types.TEMPLATE_START: 
			return started(state, action);

		case types.TEMPLATE_SUCCESS: 
			return succeeded(state, action);

		case types.TEMPLATE_FAILURE: 
			return failed(state, action);

			case types.TEMPLATE_REMOVE: 
			return removed(state, action);

		default:
			return state;
	}
};

export default templates;